import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import {
  setLastNameFilter,
  loadClientDataExcel,
  setAddClient,
  setEditClient,
  setEditMode,
} from '../../actions/advisor';
import {
  getAddClient,
} from '../../reducers/advisor';
import s from './FilterClientForm.css';

library.add(faPlus);

class FilterClientForm extends PureComponent {

  lastNameFilterChange = (event) => {
    this.props.setLastNameFilter(event.target.value);
  }

  showAddClientForm = () => {
    this.props.setAddClient(true);
  }

  goBack = () =>  {
    this.props.setEditMode('');
    this.props.setEditClient(null);
  }

  render() {
    const {
      client,
      addClient,
    } = this.props;

    const title = client ? 'PORTFOLIO ASSESSMENT' : 'YOUR CLIENT DASHBOARD';
    return (
      <div style={{marginBottom: '60px'}}>
        <div className={`row ${s.topRow}`}>
          <div className="col-md-7">
            <div className={s.title}>{title}</div>
          </div>
          <div className="col-md-5">
            { !client &&
              <div className={s.addCol} onClick={this.showAddClientForm}>
                <div className={s.addText}>ADD A CLIENT OR EXAMPLE CLIENT</div>
                <FontAwesomeIcon icon="plus" size="2x" className={s.headerIcon}/>
              </div>
            }
            { client &&
              <div className={s.returnCol} onClick={this.goBack}>
                <div className={s.returnText}>BACK TO ALL CLIENTS</div>
              </div>
            }
          </div>
        </div>
        { !client &&
        <div className={`row ${s.bottomRow}`}>
          <div className={`col-md-5`}>
              <div className={'input-group ' + s.filterCol}>
                { !addClient &&
                  <input
                    onChange={this.lastNameFilterChange}
                    type="text"
                    className={`${s.filterField} form-control ${s.formControl}`}
                    placeholder="Filter by Last Name"
                  />
                }
              </div>
          </div>
          <div className="col-md-7">&nbsp;</div>
        </div>
        }
        { client &&
        <div className={`row ${s.bottomRow}`}>
          <div className={`col-md-8`}>
              <div className={s.subTitle}>Complete Step 1 for the most comprehensive and individualized analysis</div>
          </div>
          <div className="col-md-4">&nbsp;</div>
        </div>
        }
        <div className={`row`}>
          <div className={`col-md-12`}>
            <div className={s.bottomRowLine}>&nbsp;</div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    lastNameFilter: state.advisorData.lastNameFilter,
    advisorData: state.advisorData,
    addClient: getAddClient(state),
  };
}

export default connect(mapStateToProps, {
  setLastNameFilter,
  loadClientDataExcel,
  setAddClient,
  setEditClient,
  setEditMode,
})(FilterClientForm);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/FilterClientForm.js